import Container from '@mui/material/Container';
import React, { useContext, useEffect, useState } from 'react'
import axios from "axios"
import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody, TextField, Paper, tableCellClasses, Button } from '@mui/material';
import { Box, Stack, styled } from '@mui/system';
import { AuthContext } from '../authContext/AuthContext';
import IconButton from "@material-ui/core/IconButton";
import UpdateStock from "./UpdateStock"
import EditIcon from "@material-ui/icons/Edit";
import LoaderDialog from './LoaderDialog';
const reader = require('xlsx');

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#1776d1',
    color: 'white',
  }
}));

const EodStock = () => {  
  const isMounted = React.useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const [items, setItems] = useState([]);
  const {user, shop} = useContext(AuthContext)
  const [updateDialog, setUpdateDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [stockSendAllow, setStockSendAllow] = useState(true)
  const [stockSendAllowClose, setStockSendAllowClose] = useState(true)
  const [excelDownload, setExcelDownload] = useState(true)
  const [loading, setLoading] = useState(false);
  const [stockError, setStockError] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("Loading EOD Stock ...");
  const [startDate, setStartDate] = useState()
  const [eosOpeningDate, setEosOpeningDate] = useState()
  const handleUpdateClose = () => {
    setUpdateDialog(false);
  };

  const onToggleEditMode = row => {
    setSelectedRow(row)
    setUpdateDialog(true)
  };

  const downloadEODStock = () => {
    setLoading(true);
    setLoadingMsg("Downloading EOD Stock ...");
    const stock =[]
    items.map((s) => {
      delete s['iid'];
      delete s['isEditMode']
      stock.push(s);
      return null;
    })
    let workBook = reader.utils.book_new();
    const workSheet = reader.utils.json_to_sheet(items);
    reader.utils.book_append_sheet(workBook, workSheet, `EODStock`);
    let exportFileName = `EODStock.xls`;
    reader.writeFile(workBook, exportFileName);
    setLoading(false);
  }

  const createItem = (iid, itemKey, itemName, unitOfMeasurement, sellingPriceExclTax, aggTransaction, stock) => {
    const sales = aggTransaction ? aggTransaction.sales : 0
    const salesReturn = aggTransaction ? aggTransaction.sales_return : 0
    const transferIn = aggTransaction ? aggTransaction.transfer_in : 0
    const transferOut = aggTransaction ? aggTransaction.transfer_out : 0
    const inward = aggTransaction ? aggTransaction.inward : 0
    const openingQty = (stock && stock.openingQty) ? Number.parseFloat(stock.openingQty.toFixed(3)):  0
    const closeq = (openingQty + inward + transferIn + salesReturn) - (sales + transferOut)
    const closingQty = Number.parseFloat(closeq.toFixed(3))
    const actualQty = (stock && stock.actualQty) ? Number.parseFloat(stock.actualQty.toFixed(3)) : closingQty
    const diffq = actualQty - closingQty
    const diffQty = Number.parseFloat(diffq.toFixed(3))
    const val = diffQty * sellingPriceExclTax
    const value = Number.parseFloat(val.toFixed(2)) 
    const reason = stock ? stock.reason : ''
    let row = {
      iid,
      itemKey, 
      itemName,
      isEditMode: false,
      unitOfMeasurement,
      sellingPriceExclTax,
      sales,
      salesReturn, 
      transferIn,
      transferOut,
      inward,
      openingQty,
      closingQty,
      actualQty,
      diffQty,
      value,
      reason
    };
    if(stock && stock._id) {
      row = {...row, _id: stock._id}
    }
    return row;
  }
  useEffect(() => {
    const getEosOpeningDate = async() => {
      try {
        setLoading(true)
        const res = await axios.get("/counter/EOSOpeningDate" + shop.shopkey, {headers: {token:"Bearer " + user.token}})
        if (!isMounted.current) return;
        let startDate = res.data && res.data.dateValue !== undefined ? res.data.dateValue : new Date().toISOString().split('T')[0]
        setStartDate(startDate)
        setEosOpeningDate(startDate)
        setLoading(false)
      } catch (err) {
        if (isMounted.current) setLoading(false)
        console.log(err)
      }
    };
    getEosOpeningDate();
  },[user, shop]);
  useEffect(() => {
    const getItems = async() => {
      try {
        if (isMounted.current) setLoading(true)
        let enableButton = true
        const stocksLastOpeningDateRes = await axios.get("/stocks/getStocksLastOpeningDate", {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        if (!isMounted.current) return;
        
        if(stocksLastOpeningDateRes.data.length === 0) {
          setStockError(true)
          setStockSendAllow(false)
          setStockSendAllowClose(false)
          setExcelDownload(false)
        } else {
          const aggres = await axios.post("/transactions/agg", {startDate}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
          const aggTransactions = {};
          aggres.data.map((t) => {aggTransactions[t._id] = t; return null;});

          const stocksRes = await axios.post("/stocks/getStocksByDateInput", {startDate}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
          const stocks = {};
          stocksRes.data.map((s) => {
            if(s.actualQty) {
              enableButton = false;
            } 
            stocks[s.itemKey] = s; 
            return null;
          });
          const res = await axios.get("/items", {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
          if (!isMounted.current) return;
          const data = [];
          res.data.map((item) => (item.delete === false && data.push(createItem(item._id,item.itemKey, item.itemName, item.unitOfMeasurement, item.sellingPriceExclTax, aggTransactions[item.itemKey], stocks[item.itemKey]))));
          setItems(data)
          let openingDate = new Date(startDate)
          let today = new Date();
          today.setDate(today.getDate() - 1);
          if(stocksRes.data.length === 0) {
            setStockError(true)
            setExcelDownload(false)
            setStockSendAllow(false)
            setStockSendAllowClose(false)
          } else {
            setStockError(false)
            setExcelDownload(true)
            const lastOpeningDate = new Date(stocksLastOpeningDateRes.data[0]["openingDate"])
            const currentTime = new Date();
            let enableAfter9PM = new Date(currentTime.getTime() + (330 + currentTime.getTimezoneOffset())*60000).getHours() >= 21;
            // If old stocks not closed enable button
            const todayMidnight = new Date();
            todayMidnight.setHours(0, 0, 0, 0);
            enableAfter9PM = lastOpeningDate <= todayMidnight ? true : enableAfter9PM
            setStockSendAllow((((today.getTime() <= openingDate.getTime()) && enableButton) || (lastOpeningDate.getTime() === openingDate.getTime())))
            setStockSendAllowClose((((today.getTime() <= openingDate.getTime()) && enableButton) || (lastOpeningDate.getTime() === openingDate.getTime())) && enableAfter9PM )
          }
        }
        if (isMounted.current) setLoading(false)
      } catch (err) {
        if (isMounted.current) setLoading(false)
        console.log(err)
      }
    };
    if(startDate) {
      getItems();
    }
  },[user, shop, startDate]);

  const handleEodStock = async() => {
    try {
	  setStockSendAllow(false)
      setStockSendAllowClose(false)
      setLoadingMsg("Updating EOD Stock ...")
      setLoading(true)
      let openingDate = new Date(startDate)
      openingDate.setDate(openingDate.getDate() + 1);
      const stock =[]
      items.map((s) => {
        // Closing today
        stock.push({shopkey: shop.shopkey, itemKey: s.itemKey, openingQty: s.openingQty, closingQty: s.closingQty, actualQty: s.actualQty, diffQty: s.diffQty, value: s.value, reason: s.reason, openingDate: startDate, _id: s._id})
        // Opening tomorrow
        stock.push({shopkey: shop.shopkey, itemKey: s.itemKey, openingQty: s.actualQty, openingDate})
        return null;
      })
      await axios.put("/stocks", stock, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
      const dt = openingDate.toISOString().split('T')[0]
      await axios.post("/counter/EOSOpeningDate" + shop.shopkey, {dateValue: openingDate.toISOString().split('T')[0]}, {headers: {token:"Bearer " + user.token}})
      setStartDate(dt)
      setEosOpeningDate(dt)
	  setLoading(false)
      setStockSendAllow(false)
      setStockSendAllowClose(false)
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }
  const handleEodStockDraft = async() => {
    try {
      setLoadingMsg("Updating EOD Stock Draft ...")
      setLoading(true)
      let openingDate = new Date(startDate)
      openingDate.setDate(openingDate.getDate() + 1);
      const stock =[]
      items.map((s) => {
        // Closing today
        stock.push({shopkey: shop.shopkey, itemKey: s.itemKey, openingQty: s.openingQty, closingQty: s.closingQty, actualQty: s.actualQty, diffQty: s.diffQty, value: s.value, reason: s.reason, openingDate: startDate, _id: s._id})
        return null;
      })
      await axios.put("/stocks", stock, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
      setLoading(false)
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }
  const updateStartDate = (value) => {
    setStartDate(value)
    setLoadingMsg("Loading EOD Stock Data ....")
  }
  return (
    <div>
      <Stack direction="row" justifyContent="end" alignItems="baseline" spacing={2}>
        <Box align="left" sx={{fontSize:20, fontWeight: "bold", color:"red"}}>*** Opening Date : {startDate} ***&nbsp;&nbsp;&nbsp;&nbsp;</Box>
        Select Date 
        <TextField type="date" inputProps={{max: eosOpeningDate}} defaultValue={{startDate}} InputLabelProps={{ shrink: true, }} SelectProps={{native: true}} onChange={(event)=> updateStartDate(event.target.value)} />
        {stockSendAllow && <Button color="error" variant="contained" size="large" onClick={handleEodStockDraft}>Save As Draft</Button>}
        {stockSendAllowClose && <Button color="error" variant="contained" size="large" onClick={handleEodStock}>Close</Button>}
        {excelDownload && <Button color="error" variant="contained" size="large" onClick={downloadEODStock}>Download Excel</Button>}
      </Stack>
      <Container maxWidth="false" disableGutters sx={{height: "89vh", width: "100vw"}}>
        <LoaderDialog open={loading} title={loadingMsg}/>
        <Box sx={{paddingTop: .5, paddingLeft: .5, paddingRight: .5}}>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: "89vh", minHeight: "89vh" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Key</StyledTableCell>
                      <StyledTableCell>Name</StyledTableCell>
                      <StyledTableCell>Unit Type</StyledTableCell>
                      <StyledTableCell>SP Excl Tax</StyledTableCell>
                      <StyledTableCell>Sales</StyledTableCell>
                      <StyledTableCell>Sales Return</StyledTableCell>
                      <StyledTableCell>Transfer In</StyledTableCell>
                      <StyledTableCell>Transfer Out</StyledTableCell>
                      <StyledTableCell>Inward</StyledTableCell>
                      <StyledTableCell>Opening Stock</StyledTableCell>
                      <StyledTableCell>Closing Stock</StyledTableCell>
                      <StyledTableCell>Actual Stock</StyledTableCell>
                      <StyledTableCell>Diff Stock</StyledTableCell>
                      <StyledTableCell>Value</StyledTableCell>
                      <StyledTableCell>Reason</StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!stockError && items.map((item) => (
                        <TableRow key={item.iid}>
                          <StyledTableCell>{item.itemKey}</StyledTableCell>
                          <StyledTableCell>{item.itemName}</StyledTableCell>
                          <StyledTableCell>{item.unitOfMeasurement}</StyledTableCell>
                          <StyledTableCell align="right">{item.sellingPriceExclTax}</StyledTableCell>
                          <StyledTableCell align="right">{item.sales.toFixed(3)}</StyledTableCell>
                          <StyledTableCell align="right">{item.salesReturn.toFixed(3)}</StyledTableCell>
                          <StyledTableCell align="right">{item.transferIn.toFixed(3)}</StyledTableCell>
                          <StyledTableCell align="right">{item.transferOut.toFixed(3)}</StyledTableCell>
                          <StyledTableCell align="right">{item.inward.toFixed(3)}</StyledTableCell>
                          <StyledTableCell align="right">{item.openingQty.toFixed(3)}</StyledTableCell>
                          <StyledTableCell align="right">{item.closingQty.toFixed(3)}</StyledTableCell>
                          <StyledTableCell align="right">{item.actualQty}</StyledTableCell>
                          <StyledTableCell align="right">{item.diffQty.toFixed(3)}</StyledTableCell>
                          <StyledTableCell align="right">{item.value.toFixed(2)}</StyledTableCell>
                          <StyledTableCell>{item.reason}</StyledTableCell>
                          {stockSendAllow ? (<TableCell colSpan="2"><IconButton onClick={() => onToggleEditMode(item)}><EditIcon size="small" /></IconButton></TableCell>) : (<TableCell colSpan="2"></TableCell>)}
                        </TableRow>
                    ))}
                    {stockError && <TableRow><TableCell colSpan="17">No opening stocks found</TableCell></TableRow>}
                  </TableBody>
              </Table>      
            </TableContainer>
          </Paper>
        </Box>
      </Container>
      <UpdateStock updateDialog={updateDialog} handleClose={handleUpdateClose} row={selectedRow}/>
    </div>
  )
}

export default EodStock
